import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const KYCNavUI = ({ account, page }) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI label='Company' to={`/su/accounts/${account.accountId}/kyc`} active={page === 'company'} />
      <TabLinkUI label='Directors & Employees' to={`/su/accounts/${account.accountId}/directors`} active={page === 'directors'} />
    </div>
    <div className='g_m_top_50' />
  </div>

export default KYCNavUI